import React from 'react'
import Image from 'next/image'
import styles from '../../../styles/UAEPageComponents.module.css'

const OtherFeatures = ({data, title}) => {

    const featuresData = Array.isArray(data) ? data : [];
    const count = featuresData.length;
    const cols = count % 4 === 0 ? 4 : count % 3 === 0 ? 3 : 4;
    
  return (
    <div className={styles.otherFeaturesMainWrapper}>
    <div className={styles.otherFeaturesWrapper}>
      <div className={styles.gradientSection} style={{top:"-10rem"}}>
        <div className={styles.gradientBlue}></div>
        <div className={styles.gradientOrange} style={{marginRight:"-25rem"}} ></div>
      </div>

      <div>
        <h3 className={styles.otherFeaturesHeading}>
         {title}
        </h3>
      </div>

      <div className={styles.otherFeaturesGrid} style={{ '--cols': cols }}>
        {featuresData.map((item, index) => (
          <div key={`${item.title}-${index}`} className={styles.otherFeatureCard}>
            <div className={styles.otherFeatureImage}>
              <Image src={item.image} alt={item.title} fill style={{ objectFit: 'contain' }} />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className={styles.otherFeatureTag}>{item.tag}</span>
              <h3 className={styles.otherFeatureTitle}>{item.title}</h3>
              <p className={styles.otherFeatureDesc}>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
    </div>
  )
}

export default OtherFeatures